<app-dashboard-container
	class="dashboard-cijfers"
	[factTable]="factTable"
	(doExport)="this.doExport(filterExpressions(), permanentFilterExpressions, $event)"
>
	<app-filter-panel
		[defaultFilters]="actueelFilters"
		[allFilters]="allFilters()"
		(filterExpressionsChange)="filterExpressions.set($event)"
		endpoint="/cijfers"
		[permanentFilterExpressions]="permanentFilterExpressions"
	></app-filter-panel>
	<app-filter-bar [dataRootSelection]="dataRootSelection()"></app-filter-bar>
	<section class="dashboard">
		<app-dashboard-header>
			<app-single-select-dropdown
				label="Cijfertype"
				[opties]="cijferkolomKeuzeOpties()"
				[selectedOptie]="getSelectedCijfertypeOptie()"
				(onOptieClicked)="qp.dispatch('cijfertype', $event)"
			></app-single-select-dropdown>
			@if (cijferkolomKeuze() !== "Gemiddelde" && userService.bron() === InstellingBron.Somtoday) {
				<app-single-select-dropdown
					label="Toetsdossier"
					[opties]="dossierOpties"
					[selectedOptie]="getSelectedDossierOptie()"
					(onOptieClicked)="qp.dispatch('dossier', $event)"
				></app-single-select-dropdown>
			}
			<app-legenda class="cl-header-utility" [attribute]="['x_cijfer_ov']"></app-legenda>
		</app-dashboard-header>
		<app-barchart-table
			[tableGroups]="tableGroups"
			[filters]="filterExpressions()"
			[permanentFilters]="permanentFilters()"
			[groups]="fixedGroups"
			[subgroups]="fixedSubgroups"
			[config]="this"
			[barchartWidth]="200"
		></app-barchart-table>
	</section>
</app-dashboard-container>
